import type { CSSProperties } from "react";

/** Sidebar and header sizes shared by the dashboard layout and its loading skeleton. */
export const dashboardSidebarStyle: CSSProperties &
  Record<`--${string}`, string> = {
  "--sidebar-width": "calc(var(--spacing) * 60)",
  "--header-height": "calc(var(--spacing) * 12)",
};
